import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { selectHasExecutePermissions } from 'store/selectors/user'
import Explorer from 'components/Explorer'
import { redirectTo } from 'store/actions/user'
import { useTitle } from 'hooks'
import { useHotjar } from 'utils/hotjar'
import { trackPageView } from 'utils/mixpanel'

const GiftExplorer = () => {
  const dispatch = useDispatch()
  const hasExecutePermissions = useSelector(selectHasExecutePermissions)

  useEffect(() => {
    if (!hasExecutePermissions) {
      dispatch(redirectTo('/search'))
    }
  }, [hasExecutePermissions])

  useTitle(t => t.explorer.title)

  useHotjar()

  useEffect(() => {
    trackPageView()
  }, [])

  return <Explorer />
}

export default GiftExplorer
